import styled from '@emotion/styled'

export const LoaderWrapper = styled.div`
    position: fixed;
    right: 0;
    left: 0;
    bottom: 0;
    top: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 99;
    background-color: rgba(255, 255, 255, 0.7);
`

export const LoaderContentWrapper = styled.div`
    position: relative;
`
